<template>
  <v-dialog
    persistent
    v-model="dialog"
    max-width="60vw"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-toolbar color="primary" class="elevation-0">
        <v-toolbar-title>
          <div class="heading__5">
            Store special close :
            <span style="color: grey"> {{ $route.params.store_name }}</span>
          </div></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('onClose')"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-layout wrap align-center justify-center>
          <v-flex :key="1" xs12 lg6 class="mt-3 text-xs-center">
            <v-date-picker
              :min="moment().format('YYYY-MM-DD')"
              class="elevation-4"
              no-title
              v-model="form.dateTime"
            ></v-date-picker></v-flex
          ><v-flex :key="2" xs12 lg6 class="mt-3" v-if="form.dateTime != null">
            <v-card class="elevation-4" color="#FAFAFA">
              <v-card-text>
                <v-form v-model="valid" ref="form">
                  <div style="font-weight: bold">
                    Select time <span class="ml-1" style="color: red">*</span>
                  </div>
                  <v-layout
                    wrap
                    class="mt-3"
                    justify-space-between
                    align-center
                  >
                    <v-flex xs12 lg5 class="text-xs-center">
                      <vue-timepicker
                        v-model="form.startTime"
                        class="dinein_time_picker"
                        format="HH:mm"
                        style="width: 100%"
                      /> </v-flex
                    ><v-flex xs12 lg1 class="text-xs-center ma-2">
                      <span style="font-weight: bold">to</span></v-flex
                    ><v-flex xs12 lg5 class="text-xs-center">
                      <div>
                        <vue-timepicker
                          @error="isValidTime = $event"
                          :hour-range="[[form.startTime.split(':')[0], 23]]"
                          :minute-range="[
                            [
                              form.startTime.split(':')[0] >=
                              form.endTime.split(':')[0]
                                ? form.startTime.split(':')[1]
                                : 0,
                              59,
                            ],
                          ]"
                          v-model="form.endTime"
                          class="dinein_time_picker"
                          style="width: 100%"
                          format="HH:mm"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                  <div class="mt-4" style="font-weight: bold">Enter note</div>
                  <div class="mt-2">
                    <v-textarea
                      v-model="form.description"
                      class="dinein_input_picker"
                      outline
                    ></v-textarea>
                  </div>
                  <div class="text-xs-center">
                    <v-btn
                      :disabled="
                        form.startTime.includes('HH') ||
                        form.startTime.includes('mm') ||
                        form.endTime.includes('HH') ||
                        form.endTime.includes('mm') ||
                        form.startTime == '' ||
                        form.endTime == '' ||
                        isValidTime.length > 0
                      "
                      small
                      round
                      class="elevation-0"
                      color="primary black--text"
                      @click="submit()"
                      :loading="isLoading"
                      >Submit</v-btn
                    >
                  </div>
                </v-form>
              </v-card-text>
            </v-card></v-flex
          >
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  props: {
    dialog: {},
    editedIndex: {},
    selected_item: {
      default() {
        return {};
      },
    },
    store_id: {},
  },
  data() {
    return {
      form: {
        store_id: null,
        dateTime: null,
        startTime: "",
        endTime: "",
        description: "",
      },
      valid: false,
      rules: {
        required: (value) => value == "0" || !!value || "Required.",
      },
      isLoading: false,
      isValidTime: [],
    };
  },

  components: {
    VueTimepicker,
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        if (this.editedIndex == -1) {
          this.resetForm();
          this.form.store_id = this.store_id;
        } else {
          this.form = {
            store_id: this.store_id,
            dateTime: this.selected_item.dateTime,
            startTime: this.selected_item.startTime,
            endTime: this.selected_item.endTime,
            description: this.selected_item.description,
            special_close_id: this.selected_item.id,
          };
        }
      }
    },
  },

  methods: {
    ...mapActions({}),
    resetForm() {
      this.form = {
        store_id: null,
        dateTime: null,
        startTime: "",
        endTime: "",
        description: "",
      };
    },
    submit() {
      this.isLoading = true;
      let _this = this;
      this.$emit("onSaved", {
        form: JSON.parse(JSON.stringify(this.form)),
        done() {
          console.log(123123);
          _this.isLoading = false;
          return;
        },
      });
    },
  },
};
</script>

<style scoped>
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>

<style>
.dinein_time_picker.time-picker input.display-time {
  width: 100%;
  color: rgba(0, 0, 0, 0.54);
  border: 1.5px solid #e0e0e0;
}

.dinein_input_picker.theme--light.v-text-field--outline
  > .v-input__control
  > .v-input__slot {
  border: 1.5px solid #e0e0e0;
}
</style>
